import React from 'react'
import { Link } from 'gatsby'
import Triangle from './primitives/Triangle'
import logo from '../../../../images/logo.png'
import logoW from '../../../../images/logo.webp'

import {
  Wrapper,
  LogoWrapper,
  LogoTextWrapper,
  GlobalDropDown,
} from './NavbarLogo.styles'

const NavbarLogo = ({ secondaryLogo, handleGlobalNav, active }) => {
  return (
    <Wrapper>
      <GlobalDropDown
        className={active ? 'active-global' : ''}
        onClick={handleGlobalNav}
      >
        <picture>
          <source srcSet={logoW} type="image/webp" />
          <source srcSet={logo} type="image/jpeg" />
          <img src={logo} alt="ProMazo Global Menu" />
        </picture>
        <Triangle />
      </GlobalDropDown>

      <div className="bar" />

      {secondaryLogo && (
        <Link to="/">
          <LogoWrapper>{secondaryLogo.icon}</LogoWrapper>

          {secondaryLogo.head && (
            <LogoTextWrapper>
              <h1>{secondaryLogo.head}</h1>
              <p>powered by ProMazo</p>
            </LogoTextWrapper>
          )}
        </Link>
      )}
    </Wrapper>
  )
}

export default NavbarLogo
